import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getChatToken, loginCreator } from "../../service/api.js";

function CreatorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    const data = await loginCreator({ email: email, password: password });

    if (data) {
      sessionStorage.setItem("creatordata", JSON.stringify(data));
      let creator_email = email.replaceAll(".", "_");
      creator_email = creator_email.toLowerCase();
      const token = await getChatToken(creator_email);
      sessionStorage.setItem("chattoken", JSON.stringify(token));
      navigate("/creator");
    }
  };

  return (
    <div className="flex bg flex-col h-full min-h-screen justify-center items-center p-5">
      <h1 className="text-4xl font-bold text-white m-3">Sign In</h1>

      <form className="w-full flex flex-col gap-2.5 font-semibold md:w-3/5 lg:w-1/2">
        <div className="flex flex-col gap-1">
          <label htmlFor="email" className="text-white">
            Email:
          </label>
          <div className="rounded-lg flex text-sm md:text-base items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-2.5 md:gap-4 bg-white">
            <span>
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            <input
              type="email"
              name="email"
              placeholder="Enter your Email"
              className="w-full h-full outline-none"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="password" className="text-white">
            Password:
          </label>
          <div className="rounded-lg flex text-sm md:text-base items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-2.5 md:gap-4 bg-white">
            <span>
              <FontAwesomeIcon icon={faLock} />
            </span>
            <input
              type="password"
              name="password"
              placeholder="Enter your Password"
              className="w-full h-full outline-none"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="flex justify-center items-center mt-5">
          <button
            className="rounded-full text-center w-full px-4 py-1.5 bg-white text-teal-600 font-bold"
            onClick={(e) => onSubmit(e)}
          >
            LOG IN
          </button>
        </div>
      </form>

      <div className="w-full mt-3 text-xs text-center md:text-base text-white">
        <p>
          Don't have an Account?{" "}
          <Link to="/creator/signup" className="font-bold">
            Sign UP
          </Link>
        </p>
      </div>
    </div>
  );
}

export default CreatorLogin;
